export const DEFAULT_LAYOUTS = {
  '76f4af5c-6b52-4095-9c2b-4a6ce6716fda': {
    'widgetType': 'PINEAPPLE_STUDIES',
    'location': {
      'lg': {'x': 0, 'y': 0},
      'md': {'x': 0, 'y': 1},
      'sm': {'x': 0, 'y': 0},
    },
    'settings': {},
  },
  'b54cc2ef-f6a3-4e2a-b76f-fe646e1641eb': {
    'widgetType': 'CLIENT_PAYMENT_STATUS',
    'location': {
      'lg': {'x': 16, 'y': 0},
      'md': {'x': 0, 'y': 0},
      'sm': {'x': 0, 'y': 1},
    },
    'settings': {},
  },
  '7dedcb72-cb49-4647-811c-6aeda299989f': {
    'widgetType': 'CAREGIVER_PAYMENT_STATUS',
    'location': {
      'lg': {'x': 24, 'y': 0},
      'md': {'x': 8, 'y': 0},
      'sm': {'x': 0, 'y': 2},
    },
    'settings': {},
  },
};
